import { getDateString } from "./helpers";

export const CALENDAR_VIEW = 'calendar';
export const LIST_VIEW = 'list';
export const DEFAULT_VIEW = CALENDAR_VIEW;

export const DEFAULT_DATE = getDateString(new Date());
export const DEFAULT_DATE_START = getDateString(new Date(new Date().setDate(1)));
export const DEFAULT_DATE_END = getDateString((() => {
  const date = new Date();
  const month = new Date().getMonth();

  return new Date(date.setMonth(month + 1, 0))
})());



// WEBPACK FOOTER //
// ./src/templates/pages/events/const.js